module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Birr_AG-7969f55ca03463fb56c67f1f86b2f140.svg";